import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getUsuarios } from "../../../api/ApiService";
import { DataGrid } from '@mui/x-data-grid';
import HistorialTableComponent from "./components/HistorialTableComponent";
import FitroAtcComponents from "./components/FitroAtcComponents";



function HistorialPage() {
    const [name, setName] = useState('');
    const [apellido, setApellido] = useState('');
    const [cedula, setCedula] = useState('');
    const [estado, setEstado] = useState('');
    const [items, setItems] = useState('');
    const [tipo, setTipo] = useState('');
    const [userTester, setUserTester] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataHistorial, setDataHistorial] = useState([]);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);
    const [loadingCargar, setLoadingCargar] = useState(false);




    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);



    console.log("stateToken", stateToken);
    useEffect(() => {
        if (stateToken) {
            handleListarUsuarios();
        }
    }, [stateToken]);

    const handleListarUsuarios = () => {

        getUsuarios(stateToken?.token, 1, 10)
            .then((response) => {
                console.log("response-getUsuarios", response);
                if (response.data.length > 0) {
                    setDataHistorial(response.data);
                    setLoading(true);
                } else {
                    setDataHistorial([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getUsuarios", error);
                setDataHistorial([]);
                setLoading(true);
            });
    };



    //=============================================funcion para capturar el name y cedula
    const handleName = (e) => {
        setName(e);
    }

    //=============================================funcion para capturar el apellido
    const handleApellido = (e) => {
        setApellido(e);
    }

    //=============================================funcion para capturar el cedula
    const handleCedula = (e) => {
        setCedula(e);
    }




    //=============================================funcion para seleccionar el estado
    const handleEstado = (event) => {
        console.log("event", event);
        setEstado(event);
    };

    //=============================================funcion para seleccionar el estado de verificado por email
    const handleItems = (event) => {
        console.log("event", event);
        setItems(event);
    };




    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);
    };

    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        console.log("fecha", fecha);
        setFechaFinBackend(fecha);
    };


    //=============================================funcion para seleccionar el user tester
    const handleUserTester = (event) => {
        console.log("event", event);
        setUserTester(event);
    };


    //=============================================funcion para editar
    const handleEditClick = (item) => {
        console.log('Edit', item);
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => {
        console.log('Delete', id);
        setDataHistorial(dataHistorial.filter((row) => row.id !== id));
    }








    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };



    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventos = (page = 1) => {

        // let body = {
        //     page: page,
        //     per_page: perPage,
        //     estado: statusFilter,
        //     titulo: searchFilter
        // };
        // console.log("body-handleApiFiltrarLocales", body);


        // setLoadingCargar(true);

        // getFiltrarEventos(stateToken?.access_token, body)
        //     .then(response => {
        //         // console.log("response==>", response);

        //         setLoadingCargar(false);
        //         // setMetaPaginacion(response.meta);

        //         if (response.data.length > 0) {
        //             setDataHistorial(response.data);
        //             setLoading(true);
        //         } else {
        //             setDataHistorial([]);
        //             setLoading(true);
        //         }

        //         setMetaPaginacion({
        //             current_page: response?.current_page,
        //             per_page: response?.per_page,
        //             total: response?.total,
        //             last_page: response?.last_page
        //         });


        //     })
        //     .catch(error => {
        //         console.log("error==>", error);
        //         setDataHistorial([]);
        //         setLoading(true);
        //         setLoadingCargar(false);
        //     })
    };


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitroAtcComponents
                            name={name}
                            handleName={handleName}

                            apellido={apellido}
                            handleApellido={handleApellido}

                            cedula={cedula}
                            handleCedula={handleCedula}

                            estado={estado}
                            handleEstado={handleEstado}

                            items={items}
                            handleItems={handleItems}

                            fechaInicio={fechaInicio}
                            handleFechaInicio={handleFechaInicio}

                            fechaFin={fechaFin}
                            handleFechaFin={handleFechaFin}

                            userTester={userTester}
                            handleUserTester={handleUserTester}
                        />

                        <div>
                            <HistorialTableComponent
                                data={dataHistorial}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEventos}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


            </div>
        </HeaderCustom>
    );
}

export default HistorialPage;